import {
  MILLISECONDS_IN_SECOND,
  SECONDS_PER_MINUTE,
  setTimeOutGreatestValue
} from 'utils/constants/dateInfo/time-numbers';
import { CommandNames } from 'utils/constants/swarm/swarm-command-names';
import { getGenericAccountCommand } from 'services/account-settings';

const durations: {
  [key: string]: ReturnType<typeof setTimeout>;
} = {};

export const clearRemainingSessionDurations = (): void => {
  Object.keys(durations).forEach((timeout: string) => {
    clearTimeout(durations[timeout]);

    delete durations[timeout];
  });
};

export const remainingSessionDuration = (
  configs: { [key: string]: number },
  callback: (type: string) => void
): void => {
  const createTimer = (key: string, time: number) => {
    function longTimeout(callback: () => void, timeout: number) {
      if (timeout <= 0) {
        callback();
      } else {
        durations[key] = setTimeout(function () {
          longTimeout(callback, timeout - setTimeOutGreatestValue);
        }, Math.min(timeout, setTimeOutGreatestValue));
      }
    }

    longTimeout(function () {
      callback(key);
      clearRemainingSessionDurations();
    }, time * MILLISECONDS_IN_SECOND * SECONDS_PER_MINUTE);
  };

  getGenericAccountCommand(
    CommandNames.GET_REMAINING_SESSION_DURATION.toUpperCase(),
    ({ details }: { details: { [key: string]: number } }) => {
      const times = Object.values(details || {});

      if (times?.length) {
        const timer = Math.min(...times);

        Object.entries(details || {}).forEach(([key, time]) => {
          time === timer &&
            configs[key] &&
            !durations[key] &&
            createTimer(key, time);
        });
      }
    }
  );
};
